import React, { PureComponent } from 'react';
import { Field, reduxForm, change, getFormValues, initialize } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validate,  renderMaterialField, checkValidCountries, popularCountriesArr, renderSelectField } from '../../helpers/formHelper';
import _forEach from 'lodash/forEach';
import { POPULAR_COUNTRIES, FUSE_OPTIONS } from '../../config';
import Fuse from 'fuse.js';
import { isoNameConvert } from '../../helpers/locationHelper';

const submit = (values) => {
    //console.log("DISPATCHED FROM PAYMENT PROCESSING - ", values);
}


class PassengerBilling extends PureComponent{

  constructor(props){
    super(props);
    this.state = {
      nationalityDropdown:"",
      isNationalityOpen:false,
      nationalitySearch:[],
      nationalitySearchOriginal:[],
      nationalityDropdownNumber:-1
    }
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.onNationalityChange = this.onNationalityChange.bind(this);
    this.onSelectMobile = this.onSelectMobile.bind(this);
    this.fuseNationality = null;
  }

  componentDidMount(){

    const { nationality } = this.props;

    document.body.addEventListener('click', this.documentClickHandler);

    //setup  nationality
    this.setState({
      nationalitySearch:nationality,
      nationalitySearchOriginal:nationality
    }, () => {
        this.fuseNationality = new Fuse(nationality, FUSE_OPTIONS);
    });


    //Add hover state
    setTimeout(() => {
      _forEach(document.querySelectorAll('.passenger-billing-form input'),item => {
        if(item.value !== "") {
          item.parentElement.parentElement.classList.add('hovered');
        }
      });
    },10);

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
    this.fuseNationality = null;
    this.setState({
      nationalitySearch:[],
      nationalitySearchOriginal:[]
    });
  }

  documentKeydownHandler(e){

    //Increment/Decrement dropdown cursor position
    const { isNationalityOpen, nationalityDropdownNumber } = this.state;
    const nationalityInput = document.querySelectorAll('.filterDropdown.basket ul.country.nationality li');


    if(isNationalityOpen){
      if(e.key === 'ArrowDown' && nationalityDropdownNumber < nationalityInput.length - 1){
        this.setState({nationalityDropdownNumber:nationalityDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && nationalityDropdownNumber > 0){
        this.setState({nationalityDropdownNumber:nationalityDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(nationalityInput[nationalityDropdownNumber] !== undefined){
          this.onNationalityChange(null, nationalityInput[nationalityDropdownNumber].dataset.name, nationalityInput[nationalityDropdownNumber].dataset.countrycode, false);
        }
      }
    }

  }

  componentDidUpdate(prevProps, prevState){

    const { nationalityDropdownNumber, nationalitySearch } = this.state;
    const { nationality, paxBillingValues, bookingGroup } = this.props;


    if(window.innerWidth > 639){
      if(nationalityDropdownNumber !== prevState.nationalityDropdownNumber){

        const nationalityInputContainer = document.querySelector('.filterDropdown.basket ul.country.nationality');
        const nationalityInput = document.querySelectorAll('.filterDropdown.basket ul.country.nationality li');

        for(let j = 0; j < nationalityInput.length; j++){
          nationalityInput[j].classList.remove('hover');
        }

         if(nationalityInput[nationalityDropdownNumber].dataset.name !== undefined){
          //hover state
          nationalityInput[nationalityDropdownNumber].classList.add('hover');

          //scroll container
          nationalityInputContainer.scrollTop = nationalityInput[nationalityDropdownNumber].offsetTop;
        }

      }


      if(nationalitySearch !== prevState.nationalitySearch){
        this.setState({nationalityDropdownNumber:0});
      }

    }


    //setup custom nationality flags
    if(nationality !== prevProps.nationality){
      this.setState({
        nationalitySearch:nationality,
        nationalitySearchOriginal:nationality
      }, () => {
        this.fuseNationality = new Fuse(nationality, FUSE_OPTIONS);
      });
    }


    //Populate nationality/state/phone
    if(bookingGroup !== prevProps.bookingGroup ){
      if(paxBillingValues && paxBillingValues.country !== ""){
        this.populatePaxDetails(paxBillingValues, nationality);
      }
    }

  }

  populatePaxDetails(paxDetailsValues, nationality){

    //Populate nationality/state if exist in state
    if(paxDetailsValues && paxDetailsValues.country !== "") {
        if(window.innerWidth < 640){
          this.onSelectMobile("nationality");
        }else{
          this.onNationalityChange(null, isoNameConvert(paxDetailsValues.country, "nationality", nationality, null), paxDetailsValues.country);
        }
    }

  }

  documentClickHandler(e){

    const {
      nationalityDropdown, nationalitySearchOriginal, nationalitySearch,
    } = this.state;

    try{
      if(window.innerWidth > 639){

        if(e.target.offsetParent.className === "phone country nationality"){

          this.setState({
            isNationalityOpen:false,
            nationalitySearch:(nationalityDropdown === "" || checkValidCountries(nationalitySearchOriginal, nationalityDropdown) ) ? nationalitySearchOriginal : nationalitySearch
          }, () => {
            const dividers =  document.querySelectorAll('.dividers');
              for(let i = 0; i < dividers.length; i++){
                dividers[i].classList.remove('hide');
              }
          });
        }

      }
    }catch(e){}
  }

  onDropdownClick(e, dropName){
    e.preventDefault();

    switch (dropName) {
      case 'nationality':
        this.setState({ isNationalityOpen:!this.state.isNationalityOpen });
        break;
      default:
    }
  }

  onNationalityChange(e, name, countryCode, isClose){
    this.setState({nationalityDropdown:name, isNationalityOpen:isClose}, () => {
       this.props.change('country', countryCode);
    });
  }

  onInputChange(e, inputName){
    const dividers = document.querySelectorAll('.dividers');

    if(e.target.value === ""){

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.remove('hide');
      }

      switch (inputName) {

        case 'nationality':
            this.setState({nationalityDropdown:"", nationalitySearch:this.state.nationalitySearchOriginal});
          break;

        default:

      }

    }else{

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.add('hide');
      }

      switch (inputName) {

        case 'nationality':
          this.setState({nationalityDropdown:e.target.value, nationalitySearch:this.fuseNationality.search(e.target.value)});
          break;

        default:
      }

    }

  }


  onSelectMobile(selectName){
    switch (selectName) {
      case 'nationality':
        document.querySelector('.payment-select select[name="country"]').classList.add('active');
        break;
      default:
    }
  }

  renderNationalitySelectMobile(){
    return(
      <Field name="country" component={renderSelectField} classType="payment-select" label="" onChange={e => this.onSelectMobile('nationality')}>
        <option value="" disabled>Select Country *</option>
        <option value="" disabled>----------</option>
          { popularCountriesArr(this.state.nationalitySearch, POPULAR_COUNTRIES).map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name}` : "----------------"}</option>)}
        <option value="" disabled>----------</option>
        {this.props.nationality.map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code }  disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name}` : "----------------"} </option>)}
      </Field>
    )
  }
  renderNationalitySelect(){

    const {isNationalityOpen, nationalitySearch, nationalityDropdown } = this.state;

    return(
      <div className="filterDropdown basket no-margin nationality">
        <div className="row">
          <div className="columns small-12 no-margin">
            <input type="text" placeholder="Select Country *" onClick={ e => this.onDropdownClick(e, 'nationality') } onKeyDown={e => this.documentKeydownHandler(e)} onChange={ e => this.onInputChange(e,'nationality') } value={nationalityDropdown} className={`filterDropdown-btn nationalityStateFuzzy ${isNationalityOpen ? 'active' : ''} `} />
            <i className={`fa fa-chevron-down phone ${isNationalityOpen ? 'active' : ''}`} aria-hidden="true"></i>
          </div>
           <div className="columns small-12 no-margin phone-container">
            <ul className="phone country nationality " style={{display: isNationalityOpen ? 'block':'none' }}>
              <li className="dividers" data-index="0">--------------------</li>
              {
                popularCountriesArr(nationalitySearch, POPULAR_COUNTRIES).map((item, index) => {
                  return (
                    <li
                      data-index={index + 1}
                      data-name={item.name}
                      data-countrycode={item.iso_country_code}
                      onClick={e => this.onNationalityChange(e, item.name, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                      {item.name}
                    </li>
                  )
                })
              }
              <li className="dividers" data-index={POPULAR_COUNTRIES.length + 1}>--------------------</li>
              {
                nationalitySearch.map((item, index) => {
                  return (
                    <li
                      data-index={(POPULAR_COUNTRIES.length + 2) + index}
                      data-name={item.name}
                      data-countrycode={item.iso_country_code}
                      onClick={e => this.onNationalityChange(e, item.name, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                      {item.name}
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <span className="form-error">Your country is required</span>
      </div>
    )
  }


  render(){

    const { handleSubmit, currency } = this.props;

    return (

      <div className="passenger-billing" style={{display:(currency === "" ||  currency !== "GBP" ) ? "none" : "block" }}>

      <form className="passenger-billing-form" onSubmit={handleSubmit}>

      <div className="row">
          <div className="column small-12">
            <h5 className="busabout-h5 orange-text">Billing address</h5>
            <p>Please enter the billing address registered to yor bank.</p>
          </div>
        </div>

        <div className="row">
          <div className="column small-12 medium-6 col-left-mod">
            <Field name="address" fieldId="address" component={renderMaterialField} type="text" label="Address line 1*"/>
          </div>

          <div className="column small-12 medium-6 col-right-mod">
            <Field name="address2" fieldId="address2" component={renderMaterialField} type="text" label="Address line 2"/>
          </div>
        </div>
        <div className="row">
          <div className="column small-12 medium-6 large-4 col-3-mod-left">
            <Field name="city" fieldId="city"  component={renderMaterialField} type="text" label="City"/>
          </div>

          <div className="column small-12 medium-6 large-4 col-3-mod-middle">
              {  (window.innerWidth < 640) ? this.renderNationalitySelectMobile() : this.renderNationalitySelect()  }
          </div>

          <div className="column small-12 medium-6 large-4 col-3-mod-right end">
            <Field name="postcode" fieldId="postcode" component={renderMaterialField} type="text" label="Postcode*"/>
          </div>
        </div>

      </form>

      </div>
    )
  }
}


PassengerBilling = reduxForm({
  form: 'PassengerBilling',
  validate,
  onSubmit:submit,
  destroyOnUnmount: false
})(PassengerBilling);


function mapStateToProps(state){
  return{
    paxBillingValues:getFormValues('PassengerBilling')(state),
    nationality:state.nationality,
    bookingGroup:state.bookingGroup.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    change,
    initialize
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengerBilling);



// WEBPACK FOOTER //
// ./src/components/payment/passengerbilling.js